import { render } from "./Pagenation.vue?vue&type=template&id=0593cf9f&scoped=true&ts=true"
import script from "./Pagenation.vue?vue&type=script&lang=ts"
export * from "./Pagenation.vue?vue&type=script&lang=ts"

import "./Pagenation.vue?vue&type=style&index=0&id=0593cf9f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0593cf9f"]])

export default __exports__